import { convexQuery } from '@convex-dev/react-query'
import { msg } from '@lingui/core/macro'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'
import { api } from '~convex/_generated/api'

/**
 * Kept as a redirect into the My account surface, where the profile lives.
 *
 * The rail's account menu links here rather than to the slugged URL because
 * the rail also renders on `/admin`, where no workspace is in focus and there
 * is no slug to link with. Resolving the caller's last-visited workspace here
 * means every entry point can just say `/profile`.
 */
export const Route = createFileRoute('/_authenticated/profile')({
  beforeLoad: async ({ context }) => {
    const workspace = await context.queryClient.ensureQueryData(
      convexQuery(api.workspaces.defaultWorkspace, {})
    )
    if (workspace === null) {
      // No workspace to hang settings off — `/home` owns the create-one CTA.
      throw redirect({ to: '/home' })
    }
    throw redirect({
      params: { workspaceSlug: workspace.slug },
      to: '/$workspaceSlug/account/profile',
    })
  },
  head: () => ({ meta: [{ title: titleFor(msg`Profile`) }] }),
})
